import script from "./ChangePasswordPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangePasswordPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__